import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';
import { ProjectSettingService } from 'src/app/pages/projects/services/project-setting.service';
import { SettingsPageService } from '../../settings-service/settings-page.service';

@Component({
  selector: 'app-event-modal',
  templateUrl: './event-modal.component.html',
  styleUrls: ['./event-modal.component.scss']
})
export class EventModalComponent implements OnInit {

  @ViewChild("modal") modal!: ElementRef;
  @Output() updateTable: EventEmitter<any> = new EventEmitter();

  projectId: number | null = null;
  modalTitle: string;

  eventForm!: FormGroup;
  submitted: boolean = false;
  modalRef: NgbModalRef;
  loading: boolean = true;
  types: any[];
  disableTypeSelect: boolean = false;

  constructor(protected settingSrv: SettingsPageService,
    protected projSettingSrv: ProjectSettingService,
    protected modalService: NgbModal,
    protected fb: FormBuilder,
    public translateService: TranslateService,
    protected utilSrv: UtilsService) {
    this.types = [
      { label: 'Event', value: 'EVENT' },
      { label: 'Task', value: 'TASK' },
      { label: 'Notification', value: 'NOTIFICATION' },
    ];
  }

  ngOnInit(): void {
    this.setForm();
  }

  get formEvent() { return this.eventForm.controls; }

  setForm() {
    this.eventForm = this.fb.group({
      TypeEN: ['', Validators.required],
      Id: [0],
      Color: [''],
      Type: ['', Validators.required],
    });
  }

  openModal( type: string, data: any, projectId?: number | null, typeOption?: string) {
    this.loading = true;
    this.setForm();

    if (projectId) this.projectId = projectId;
    this.modalTitle = type === 'addEvent' ? 'SETTINGS.EVENT.ADDEVENT' : 'SETTINGS.EVENT.EDITEVENT';

    if (typeOption) {
      this.eventForm.controls['Type'].setValue(typeOption);
      this.disableTypeSelect = true;
    }

    if (type === 'editEvent') this.fillForm(data);
    else this.loading = false;
    this.modalRef = this.modalService.open(this.modal, { centered: true, backdrop: 'static', keyboard: false });
  }

  fillForm(data: any) {
      this.eventForm.controls['Id'].setValue(data.id);
      this.eventForm.controls['Color'].setValue(data.color);
      this.eventForm.controls['TypeEN'].setValue(data.description);
      this.eventForm.controls['Type'].setValue(data.type);

      this.loading = false;
  }

  save() {
    this.submitted = true;
    if (this.eventForm.valid) {
      this.loading = true;
      const data: any = {
        type: this.formEvent.Type.value,
        description: this.formEvent.TypeEN.value,
        clientDescription: this.formEvent.TypeEN.value,
        color: this.formEvent.Color.value !== '' ? this.formEvent.Color.value : null,
      };

      if (this.projectId) {
        data['projectId'] = this.projectId;
      }

      const id = this.formEvent.Id.value;
      let request;
      if (this.projectId) {
        request = id === 0 ? this.projSettingSrv.createConfig(this.projectId, data) : this.projSettingSrv.updateConfig(this.projectId, id, data);
      } else request = id === 0 ? this.settingSrv.registerConfigurations(data) : this.settingSrv.updateConfiguration(data, id);

      request.pipe(finalize(() => {

        this.updateTable.emit();
        this.loading = false;
      })).subscribe((data: any) => {
        const successMsg = id === 0 ? 'SETTINGS.CREATED' : 'SETTINGS.UPDATED';
        this.utilSrv.notify(successMsg, 'success').then(() => {
          this.setForm();
          this.submitted = false;
          this.modalRef.close();
        });
      }, (error: any) => {
        console.error('Save', error);
        this.utilSrv.notify('SETTINGS.ERROR', 'error');
      });
    }
  }

  closeModal() {
    this.submitted = false;
    this.eventForm.reset();
    this.modalRef.close();
  }

}
